
const { Component } = React;


export default class Promotions extends Component {
  static defaultProps = {
    promotions: [],
    lastMinuteDeals: {},
    countdown: { date: '2010-10-10' }
  }

  getPromotions() {
    return this.props.promotions.map((promotion, promoIndex) => {
      return (<a
        className="btn-sale js-magnific-popup"
        href="#promotionsModal"
        key={`${promotion.title}${promoIndex}`}
        onClick={() => this.props.viewPromotionDetails(promotion.description, promotion.title)}>
        {promotion.title}
      </a>);
    });
  }

  render() {
    
    return (
      <div className="below-book">
        <p className="promotions-at-resort">promotions at this resort</p>
        {this.getPromotions()}
        {/*(Object.values(this.props.lastMinuteDeals).reduce((a, obj) => a + Object.keys(obj).length, 0) > 0) && 
         <a className="btn-sale" href={`/deals/last-minute-travel-deals/?rstCode=${this.props.rstcode}`}>
           Last Minute Deal 
         </a> 
        */}
      </div>
    );
  }
}
